// Dynamically load Jam.dev scripts after the app is ready.
// Keep legacy-friendly syntax (no optional chaining / async-await).

function parseQuery() {
    try {
        var url = new URL(window.location.href);
        var out = {};
        url.searchParams.forEach(function(value, key) {
            out[key] = value;
        });
        return out;
    } catch (e) {
        var params = {};
        var q = window.location.search || '';
        if (q.indexOf('?') === 0) q = q.slice(1);
        var parts = q.split('&');
        for (var i = 0; i < parts.length; i++) {
            var kv = parts[i].split('=');
            if (kv.length >= 2) {
                var k = kv.shift();
                var v = kv.join('=');
                params[decodeURIComponent(k)] = decodeURIComponent(v);
            }
        }
        return params;
    }
}

export function shouldEnableJam() {
    if (typeof window === 'undefined') return false;
    try {
        var qp = parseQuery();
        if (qp && qp.jam === '1') return true;
    } catch (e) {}
    try {
        return localStorage.getItem('bb_enable_jam') === '1';
    } catch (e) {}
    return false;
}

function appendModuleScript(src, onload) {
    try {
        var s = document.createElement('script');
        s.type = 'module';
        s.src = src;
        if (typeof onload === 'function') s.onload = onload;
        document.head.appendChild(s);
    } catch (e) {}
}

export function loadJamScripts() {
    if (typeof window === 'undefined') return;
    if (!shouldEnableJam()) return;
    // Ensure we only load once.
    try {
        if (window.__bb_jam_loaded) return;
        window.__bb_jam_loaded = true;
    } catch (e) {}

    // Load recorder first, then capture.
    appendModuleScript('https://js.jam.dev/recorder.js', function() {
        appendModuleScript('https://js.jam.dev/capture.js');
    });
}

